import { api } from '../../../services/api/axios';
import { authService } from '../../auth/services/authService';

export interface CheckoutPayload {
  items: { cart_key: string }[];
  address_id: string;
  currency: string;
  // ❌ card_token ไม่จำเป็นแล้ว — PaySolutions จัดการ card เอง
}

export interface CheckoutResponse {
  success: boolean;
  order_id?: number;
  transaction_id?: string;
  redirect_url?: string;  // ✅ URL สำหรับ redirect ไปหน้า PaySolutions
  message?: string;
}

export interface OrderStatusResponse {
  order_id: number;
  status: string;         // 'pending' | 'processing' | 'completed' | 'failed'
  transaction_id?: string;
}

export const checkoutService = {
  placeOrder: async (payload: CheckoutPayload): Promise<CheckoutResponse> => {
    const token = authService.getToken();
    try {
      const response = await api.post('/checkout', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  // ✅ Poll order status หลัง redirect กลับมาจาก PaySolutions
  getOrderStatus: async (orderId: number): Promise<OrderStatusResponse> => {
    const token = authService.getToken();
    try {
      const response = await api.get(`/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // WP /orders/{id} returns { success, order: { order_id, status, ... } }
      return {
        order_id:       response.data.order.order_id,
        status:         response.data.order.status,
        transaction_id: response.data.order.transaction_id,
      };
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },
};
